// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".has-border-bottom-grey-light[data-v-52af3e72]{border-bottom:1px solid #dbdbdb}.color-tertiary[data-v-52af3e72]{color:#2cd5c4}.color-primary[data-v-52af3e72]{color:#ef4a81}.color-grey-darker[data-v-52af3e72]{color:#363636}.color-grey[data-v-52af3e72]{color:#7a7a7a}.help.is-danger[data-v-52af3e72]{position:static}.dashboard-complete[data-v-52af3e72]{display:flex;flex-direction:column;grid-gap:4rem;gap:4rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
